import React from 'react';
import { Target, Heart, Lightbulb, Users2 } from 'lucide-react';

const OurValues = () => {
  const values = [
    {
      icon: Target,
      title: 'Customer Obsession',
      description: 'We win when our customers succeed. Every decision starts with their needs.'
    },
    {
      icon: Lightbulb,
      title: 'Innovation & Excellence',
      description: 'We push boundaries and hold ourselves to the highest standards.'
    },
    {
      icon: Users2,
      title: 'Team First',
      description: 'We collaborate, support each other, and celebrate wins together.'
    },
    {
      icon: Heart,
      title: 'Bias for Action',
      description: 'We move fast, iterate, and learn. Perfect is the enemy of progress.'
    }
  ];

  return (
    <section className="py-20 px-6 bg-gray-900">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-4">
            Our Values
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            The principles that guide how we work and build together.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map((value, index) => (
            <div
              key={index}
              className="bg-gray-800 rounded-xl p-6 border border-gray-700 text-center"
            >
              <div className="w-12 h-12 bg-blue-900/30 border border-blue-700 rounded-xl flex items-center justify-center mx-auto mb-4">
                <value.icon className="w-6 h-6 text-blue-400" />
              </div>
              <h3 className="text-lg font-bold text-white mb-2">{value.title}</h3>
              <p className="text-gray-400 text-sm">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurValues;